import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import {
  formatPostDate,
  getPostBySlug,
  getRelatedPosts,
} from '../../data/blogPosts';
import { BlogPostSeo } from '../Seo/BlogSeo';
import HousingReformWave from './HousingReformWave';
import './Blog.css';

export default function BlogPost() {
  const { slug } = useParams();
  const post = getPostBySlug(slug);

  if (!post) {
    return <Navigate to="/blog" replace />;
  }

  if (post.interactive) {
    return <HousingReformWave post={post} />;
  }

  const related = getRelatedPosts(post.slug, 2);

  return (
    <div className="blog-page font-bai">
      <BlogPostSeo post={post} />

      <section className="blog-hero">
        <div className="max-w-3xl mx-auto px-6 md:px-12 py-14 md:py-20">
          <Link to="/blog" className="blog-post-back">
            ← All posts
          </Link>
          <p className="blog-kicker mb-4">
            {post.category} · <time dateTime={post.date}>{formatPostDate(post.date)}</time>
          </p>
          <h1 className="blog-title mb-5" style={{ fontSize: 'clamp(1.75rem, 4vw, 2.75rem)' }}>
            {post.title}
          </h1>
          <p className="blog-lede">{post.lede}</p>
        </div>
      </section>

      {post.cover ? (
        <div className="blog-post-cover">
          <img src={post.cover} alt={post.coverAlt || ''} />
        </div>
      ) : null}

      <article className="blog-article" itemScope itemType="https://schema.org/BlogPosting">
        <meta itemProp="headline" content={post.title} />
        <meta itemProp="datePublished" content={post.date} />
        {(post.body || []).map((block, index) => {
          if (block.type === 'h2') {
            return <h2 key={index}>{block.text}</h2>;
          }
          if (block.type === 'ul' && Array.isArray(block.items)) {
            return (
              <ul key={index}>
                {block.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            );
          }
          return <p key={index}>{block.text}</p>;
        })}
      </article>

      {related.length ? (
        <section className="blog-related">
          <div className="max-w-5xl mx-auto px-0 md:px-6">
            <p className="blog-kicker mb-2" style={{ color: 'var(--blog-clay)' }}>
              Keep reading
            </p>
            <h2 className="text-2xl font-bold text-warm-900 mb-2">Related notes</h2>
            <div className="blog-related-grid">
              {related.map((item) => (
                <Link key={item.slug} to={`/blog/${item.slug}`} className="blog-card">
                  <div className="blog-card-media">
                    <img src={item.cover} alt={item.coverAlt || ''} loading="lazy" />
                  </div>
                  <div className="blog-card-body">
                    <div className="blog-card-meta">
                      <span className="blog-card-cat">{item.category}</span>
                      <span aria-hidden="true">·</span>
                      <time dateTime={item.date}>{formatPostDate(item.date)}</time>
                    </div>
                    <h3 className="blog-card-title">{item.title}</h3>
                    <span className="blog-card-cta">Read →</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      ) : null}

      <section className="blog-cta-band">
        <h2>Talk with Construx</h2>
        <p>
          Whether you&apos;re planning a backyard unit or building them for clients,
          we&apos;d like to hear from you.
        </p>
        <Link to="/interest" className="blog-btn">
          Contact us
        </Link>
      </section>
    </div>
  );
}
